import {Injectable} from '@angular/core';
import {TextContentModel} from '../models/text.content-model';
import {LocaleManager} from '../../managers/locale.manager';
import {LocaleEnum} from "../../enums/locale.enum";

@Injectable()
export class TextRenderer {

    constructor(
        private readonly localeManager: LocaleManager,
    ) {
    }

    async render(contentModel: TextContentModel): Promise<string> {
        switch (this.localeManager.getCurrentLocale()) {
            case LocaleEnum.French:
                return contentModel.fr;
            case LocaleEnum.English:
                return contentModel.en;
        }
    }
}
